import { delegateInit } from './BaseShape';
import { ReturnStatement } from './ReturnStatement';

const ENTITY_FIELD_NAME = 'ExportDeclaration';

export default delegateInit(ReturnStatement, ENTITY_FIELD_NAME);
